export const ROOT = "/"
export const DASHBOARD = "/dashboard"
export const CAMERAS = "/cameras"
export const CAMERA_DETAILS = "/cameras/:cameraId"
export const OCCUPANCY = "/occupancy"
export const DEVICES = "/devices"
export const EDIT_DEVICE = "/devices/:type/:deviceId"
export const NVR_CAMERA_SYNC = "/nvr-camera-sync/:deviceId"
export const SITE_MAP = "/site-map"
export const NOTIFICATIONS = "/notifications"
export const ANALYTICS = "/analytics"
export const ACCESS_CONTROL = "/access-control"
export const MEMBERS = "/members"
export const SETTINGS = "/settings"
export const SETTINGS_ORGANIZATION = "/settings/organization"
export const ADD_SITE = "/settings/organization/add-site"
export const HELP = "/help"
export const ADD_DEVICE = "/add-device"
export const CREATE_ORGANIZATION = "/create-organization"
export const DELETED_DEVICES = "/settings/deleted-devices"
export const CATALOGS = "/catalogs"
export const CATALOG_DEVICE_CATEGORIES = "/catalogs/device-categories"
export const CATALOG_DEVICE_MODEL_GROUPS = "/catalogs/device-model-groups"
export const CATALOG_DEVICE_MODELS = "/catalogs/device-models"

export const ROUTE_METADATA = {
  [DASHBOARD]: {
    label: "Dashboard",
    icon: "dashboard",
    showInNav: true,
    category: "OVERVIEW",
  },
  [CAMERAS]: {
    label: "Live Cameras",
    icon: "cameras",
    showInNav: true,
    category: "OVERVIEW",
  },
  [OCCUPANCY]: {
    label: "Occupancy",
    icon: "occupancy",
    showInNav: true,
    category: "OVERVIEW",
  },
  [DEVICES]: {
    label: "Devices",
    icon: "devices",
    showInNav: true,
    category: "OVERVIEW",
  },
  [SITE_MAP]: {
    label: "Site Map",
    icon: "sitemap",
    showInNav: true,
    category: "OVERVIEW",
  },
  [NOTIFICATIONS]: {
    label: "Notifications",
    icon: "notifications",
    showInNav: true,
    category: "OVERVIEW",
  },
  [ANALYTICS]: {
    label: "Analytics",
    icon: "analytics",
    showInNav: true,
    category: "OVERVIEW",
  },
  [ACCESS_CONTROL]: {
    label: "Access control",
    icon: "access_control",
    showInNav: true,
    category: "OVERVIEW",
  },
  [SETTINGS_ORGANIZATION]: {
    label: "Organization",
    icon: "settings",
    showInNav: true,
    category: "SETTINGS",
  },
  [HELP]: {
    label: "Help",
    icon: "help",
    showInNav: true,
    category: "OVERVIEW",
  },
   [DELETED_DEVICES]: {
    label: "Deleted Devices",
    icon: "deleted_devices",
    showInNav: true,
    category: "SETTINGS",
  },
  [MEMBERS]: {
    label: "Members",
    icon: "members",
    showInNav: true,
    category: "SETTINGS",
  },
}

export const NAV_CATEGORIES = {
  OVERVIEW: "OVERVIEW",
  SETTINGS: "SETTINGS",
}

export const NAV_LABELS = {
  DASHBOARD: "Dashboard",
  LIVE_CAMERAS: "Live Cameras",
  OCCUPANCY: "Occupancy",
  DEVICES: "Devices",
  SITE_MAP: "Site Map",
  NOTIFICATIONS: "Notifications",
  ANALYTICS: "Analytics",
  ACCESS_CONTROL: "Access control",
  SETTINGS: "Settings",
  ORGANIZATION: "Organization",
  HELP: "Help",
  DELETED_DEVICES: "Deleted Devices",
  MEMBERS: "Members",
}

export const UNAUTHORIZED = "/unauthorized"
